import { MouseEventHandler } from 'react';
import { useIntl } from 'react-intl';
import { getIDFromUrl } from '@rossum/api-client';
import { EditRelation } from '@rossum/api-client/relations';
import { IconCustomSplitDone } from '@rossum/ui/icons/tabler';
import { Link, SvgIcon, Tooltip } from '@rossum/ui/material';
import { EditDocumentsRestrictor } from '../../../components/Restrictors';
import { getEditModeUrl } from '../../../lib/url';
import { useIsFeatureEnabled } from '../../feature-enablement/featureEnablement';

export const DocumentWasEdited = ({
  edit,
  onClick,
  childAnnotationId,
  dataCySuffix,
}: {
  edit: EditRelation;
  onClick?: MouseEventHandler;
  childAnnotationId: number;
  dataCySuffix: string;
}) => {
  const intl = useIntl();

  const isSplitEnabled = useIsFeatureEnabled('mat-1949-splitting-view');

  const editParentUrl = getEditModeUrl(isSplitEnabled, {
    id: getIDFromUrl(edit.parent),
    query: { from: childAnnotationId },
  });

  return (
    <EditDocumentsRestrictor>
      <Tooltip
        title={intl.formatMessage({
          id: 'containers.editDocument.documentWasEdited.tooltip',
        })}
        placement="top"
      >
        <div onClick={(...args) => onClick && onClick(...args)}>
          <Link
            href={editParentUrl}
            sx={{
              display: 'flex',
              alignItems: 'center',
              color: 'inherit',
              '&:hover': {
                color: 'inherit',
              },
            }}
            data-cy={`edited-document-indicator-${dataCySuffix}`}
          >
            <SvgIcon fontSize="medium" color="inherit">
              <IconCustomSplitDone />
            </SvgIcon>
          </Link>
        </div>
      </Tooltip>
    </EditDocumentsRestrictor>
  );
};
